@if (app) {
  <div class="manage-users">
    <div class="users">
      <h3>
        Add/Remove Staff Users

        <button
          class="small green"
          (click)="addUser()"
        >
          <i class="far fa-plus"></i> Add User
        </button>
      </h3>

      <motn-sort-table
        [table$]="table$"
      ></motn-sort-table>
    </div>
  </div>
}
